<template>
  <div class="kurse">
    <h1>Kurse</h1>
    <ul>
      <li><router-link to="/stillvorbereitung/">Stillvorbereitung</router-link></li>
      <li><router-link to="/schlafworkshop/">Schlafworkshop</router-link></li>
      <li><router-link to="/beikostworkshop/">Beikostworkshop</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Kurse'
}
</script>

<style scoped>
.kurse {
}
</style>